module.exports = __webpack_public_path__ + "static/media/flatProfileTrans.5eb29dfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/flatProfileTrans.png
// module id = 220
// module chunks = 1